export default __webpack_public_path__ + "images/classification_upload_classified-7nI7x.png";